<div class="flex flex-col items-stretch p-12">
	<ng-container #unsupported *ngIf="unsupportedContext; else contextSelect">
		<h3 class="mb-4">Context Unsupported</h3>

		<p class="text-grey mb-6">
			Sorry this context is currently unsupported, please send us a message if
			you'd like support.
		</p>

		<div class="flex flex-1 justify-stretch">
			<app-button
				btn="border"
				class="flex-1"
				cssClasses="button flex-1"
				(onClick)="cancel()"
				>Close</app-button
			>
		</div>
	</ng-container>
	<ng-template #contextSelect>
		<ng-container *ngIf="items.length; else add">
			<h3 class="mb-4">
				Select {{ friendlyContextAccessors[contextAccessor] }}
			</h3>

			<p class="text-grey mb-8 font-normal">
				You must select a
				{{ friendlyContextAccessors[contextAccessor] | lowercase }}
				{{ requiredSubContextText ? 'with a ' + requiredSubContextText : '' }}
				to create a document from this template.
			</p>

			<div class="flex flex-col gap-y-4 mb-8">
				<ng-container *ngFor="let item of items">
					<div
						class="flex flex-grow border rounded-lg p-4 justify-between items-center"
						(click)="selectContextItem(item)"
						[ngClass]="
							item.disabled
								? 'border-grey-light bg-grey-lightest text-grey-light'
								: selectedItem?.id === item.id
									? 'bg-green-lightest border-green text-green'
									: 'hover:border-grey-lighter hover:bg-grey-lighter border-grey-light cursor-pointer'
						"
					>
						<div class="flex min-w-0">
							<span class="truncate"
								>{{ item.name
								}}<span *ngIf="item.disabled" class="text-grey-light"
									><br />There is no
									{{ document.groupType.toLowerCase() }} department
									information</span
								></span
							>
							<div
								class="flex text-green underline cursor-pointer self-center min-w-[80px] ml-4"
								*ngIf="item.disabled"
								(click)="navigateToJurisdiction()"
							>
								Add Now
							</div>
						</div>
					</div>
				</ng-container>
			</div>

			<div class="flex flex-1 justify-stretch gap-4">
				<app-button
					btn="border"
					class="flex-1"
					cssClasses="button flex-1"
					(onClick)="cancel()"
					>Cancel</app-button
				>
				<app-button
					btn="primary"
					class="flex-1"
					cssClasses="button flex-1"
					[disabled]="!selectedItem"
					(onClick)="continue()"
					>Continue</app-button
				>
			</div>
		</ng-container>
	</ng-template>
	<ng-template #add>
		<h3 class="mb-4">Add a {{ friendlyContextAccessors[contextAccessor] }}</h3>

		<p class="text-grey mb-6">
			You must add a {{ friendlyContextAccessors[contextAccessor] | lowercase
			}}{{ requiredSubContextText }} to the file to create a document from this
			template.
		</p>

		<div class="flex flex-1 justify-stretch gap-4">
			<app-button
				btn="border"
				class="flex-1"
				cssClasses="button flex-1"
				(onClick)="cancel()"
				>Cancel</app-button
			>
			<app-button
				btn="primary"
				class="flex-1"
				cssClasses="button flex-1"
				(onClick)="addNew()"
				>Add {{ friendlyContextAccessors[contextAccessor] }}</app-button
			>
		</div>
	</ng-template>
</div>
